export default "__VITE_ASSET__B8c7DFT___"